// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__hcm_R","skeleton-animation":"Skeleton_skeleton-animation__GQV3n"};